/* Measurement is inactive until a separate, explicitly authorized test launch. */
(() => {
  'use strict';
  const node=document.getElementById('bun-experiment-config');
  if(!node)return;
  let config;try{config=JSON.parse(node.textContent);}catch{return;}
  node.dataset.status='disabled';
  if(config.enabled!==true || !config.rolloutId || !config.startsAt || !config.endsAt)return;
  const params=new URLSearchParams(location.search);
  if(window.Shopify?.designMode || /shopifypreview\.com$/.test(location.hostname) || ['preview_theme_id','preview_key','view','bun_qa'].some(k=>params.has(k)))return;
  let productId=Number(document.querySelector('[data-bun-root]')?.dataset.productId || window.ShopifyAnalytics?.meta?.product?.id);
  if(!config.productIds.includes(productId))return;
  const arm=document.querySelector('[data-bun-root]')?'new':'old';
  const key='bun_experiment_'+config.id;
  const allowed=()=>window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true;
  let active=false,participant,exposure,observer;
  const sent=new Set();
  const valid=()=>allowed()&&Date.now()>=config.startsAt&&Date.now()<config.endsAt;
  function publish(kind,more={}){
    if(!active||!valid()||document.visibilityState!=='visible')return false;
    try{window.Shopify.analytics.publish('bun_experiment_event',{schema_version:1,experiment_id:config.id,rollout_id:config.rolloutId,arm,participant_id:participant,exposure_id:exposure,product_id:productId,kind,...more});return true;}catch{return false;}
  }
  function scroll(){const depth=Math.min(100,Math.round((scrollY+innerHeight)/document.documentElement.scrollHeight*100));[25,50,75,90,100].forEach(n=>{if(depth>=n&&!sent.has(n)&&publish('scroll_depth',{threshold:n}))sent.add(n);});}
  function stop(){active=false;node.dataset.status='consent-denied';window.removeEventListener('scroll',scroll);observer?.disconnect();try{localStorage.removeItem(key);}catch{}}
  function start(){
    if(active||!valid()||!window.Shopify?.analytics?.publish||document.visibilityState!=='visible')return;
    let previous;try{previous=JSON.parse(localStorage.getItem(key)||'null');}catch{}
    if(previous?.expires<=Date.now())previous=null;
    participant=previous?.participant||crypto.randomUUID();exposure=crypto.randomUUID();
    try{localStorage.setItem(key,JSON.stringify({participant,firstArm:previous?.firstArm||arm,expires:config.endsAt}));}catch{}
    active=true;node.dataset.status='active';publish('pdp_view',{first_exposure:!previous,first_arm:previous?.firstArm||arm,crossover:!!previous&&previous.firstArm!==arm});
    window.addEventListener('scroll',scroll,{passive:true});scroll();
    observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting&&publish('section_seen',{section:e.target.dataset.section||e.target.id||'description'}))observer.unobserve(e.target);}),{threshold:.25});
    document.querySelectorAll('[data-bun-root] section[id],[data-bun-root] [data-section],product-info,.product__description,.jdgm-review-widget').forEach(el=>observer.observe(el));
  }
  document.addEventListener('visitorConsentCollected',()=>allowed()?start():stop());
  document.addEventListener('bunv3:ready',event=>{
    const nextId=Number(event.detail?.productId);
    if(nextId===productId||!config.productIds.includes(nextId))return;
    active=false;window.removeEventListener('scroll',scroll);observer?.disconnect();
    productId=nextId;sent.clear();start();
  });
  document.addEventListener('visibilitychange',()=>{if(document.visibilityState==='visible')start();});
  if(window.Shopify?.loadFeatures)window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],error=>{if(!error)start();});else start();
})();
